export default __webpack_public_path__ + "static/media/placeholder-coin.3098819b.png";